var rtl_default = {
  "rtl": "_8z6tR",
  "ltr": "YlsQ-"
};
export {
  rtl_default as default
};
//# sourceMappingURL=rtl-scss.js.map
